// 登录组件配置
const loginOptions = {
  // 选填----默认空字符串：ERP和JDPIN两种登录方式。ERP: 只有ERP一种登录方式。JDPIN：只有JDPIN一种登录方式。
  onlyOneLoginType: '',
  // 必填----登录类型： ERP、JDPIN
  loginType: '',
  // 选填----JDPIN登录按钮的样式配置码，passport.jd.com里面会根据这个参数设置对应的按钮样式
  btnTag: '3f27ccc4f27be804',
  // 必填----这个需要向passport.jd.com那边申请个自己应用的ID
  from: 'bianque',
  // 必填----登录页面的URL, 可以不需要带协议和域名
  loginUrl: '/logo',
};

/**
 * @desc 判空
 * @param data 转换的字符串
 * @return {Boolean} 空=>true 非空=>false
 */
function isEmpty(data) {
  if (data === '') {
    return true;
  } else if (data === null) {
    return true;
  } else if (data === undefined) {
    return true;
  } else {
    return false;
  }
}
/**
 * 时间对象转成时间字符串
 * @param date 时间对象
 * @param fmt 时间格式yyyy-MM-dd hh:mm:ss
 * @return {String} 2020-11-01 00:00:00格式的时间字符串
 */
export function dateFormatToString(date, fmt) {
  let res = fmt;
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(res)) {
    res = res.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  Object.keys(o).forEach(k => {
    if (new RegExp(`(${k})`).test(res)) {
      res = res.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
    }
  });
  return res;
}
/**
 * 时间戳转换
 * @param val 需要转换的时间戳
 * @return {String} 2020-11-01 00:00:00格式的时间字符串
 */
function timetamp(val) {
  var date = new Date(val);
  var YY = date.getFullYear() + "-";
  var MM =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hh =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var mm =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var ss =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return YY + MM + DD + " " + hh + mm + ss;
}

/**
 * 正则去除全部特殊字符
 * @param data 转换的字符串
 * @return {String} 去除特殊字符后的字符串
 */
function removalSpace(data) {
  let patrn = /[`~!@#$^&*+()=|{}':;',\\\[\]\<>\/?~！@#￥%“”《》’‘……&*（）——|{}【】'；：""'。，、？\s]/g;
  return data = data.replace(patrn, '');
}

/**
 * 校验是否存在特殊字符
 * @param data 转换的字符串
 * @return {Boolean} 包含特殊字符=>false 未包含=>true
 */
function specialCharacters(data) {
  let patrn = /[`~!@#$^&*+()=|{}':;',\\\[\]\<>\/?~！@#￥%“”《》’‘……&*（）——|{}【】'；：""'。，、？\s]/g;
  if (!patrn.test(data)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 校验是否存在特殊字符
 * @param data 转换的字符串 / 数字
 * @return {Boolean} 是否是数字 非数字=>false 数字=>true 为空 => true
 */
function checkNumber(data) {
  var reg = /^((([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/;
  if (reg.test(data)) {
    return true;
  } else if (data === '') {
    return true;
  } else if (data === null) {
    return true;
  } else if (data === undefined) {
    return true;
  } else {
    return false;
  }
}

// 图片校验
function copyPictureCheck(data, _this) {
  let reg = /data:image(.*);base64/g;
  let status = true;
  if (typeof (data) == 'string') {
    if (reg.test(data)) {
      _this.$message.error("目前暂不支持复制图片，请使用添加图片功能上传图片")
      status = false;
    }
  }else if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      if (reg.test(data[i].paragraphContent)) {
        _this.$message.error("目前暂不支持复制图片，请使用添加图片功能上传图片")
        status = false;
        break;
      }
    }
  }
  return status;
}

function account_type_error(code) {//业务不存在
  var popwin = $('#account_type_error_123');
  var isInner = [40004, 40005, 40006].indexOf(code) > -1;
  if (popwin.length > 0) {
    isInner ? popwin.show() : popwin.show().next().show();
  } else {
    var msg =
      code == 40004 ? '无当前菜单权限！' :// 无权限访问菜单
        code == 40005 ? '无当前菜单权限！' :// 无登录态
          code == 40006 ? '无当前菜单权限！' :// 鉴权失败
            code == '1400' ? '无当前系统操作权限！' :// 租户不存在
              code == '1406' ? '无当前系统操作权限！' :// 运营不存在
                code == '1401' ? '无当前系统操作权限！' :// 租户已失效
                  code == '1409' ? '无当前系统操作权限！' : // 租户管理员状态无效
                    code == '2406' ? '无当前系统操作权限！' : // 创作者账号已冻结
                      code == '2407' ? '无当前系统操作权限！' : // 创作者审核被驳回
                        '系统出错！';
    // 不覆盖菜单和头部,只覆盖内容部分
    if (isInner) {
      popwin = $(`<div id="account_type_error_123">
      <div style="position:absolute;top:0;left:0;width:100%;height:100%;background:#000;opacity:.75;z-index:10;"></div>
      <div style="position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);width:400px;height:200px;background:#fff;z-index:11;">
        <p style="padding:30px 20px 20px 20px;line-height: 30px;font-size: 16px;">${msg}</p>
      </div>
    </div>`);
      $('.content').append(popwin)
    } else {
      popwin = $(`<div id="account_type_error_123" role="dialog" aria-modal="true" aria-label="系统提示" class="el-message-box__wrapper" style="z-index: 200001;">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>系统提示</span>
          </div>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>${msg}</p>
            </div>
          </div>
          <div class="el-message-box__errormsg" style="visibility: hidden;"></div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" onclick="sessionStorage.removeItem('tenantId');location.href='/index';" class="el-button el-button--default el-button--small el-button--primary">
            <span>确定</span>
          </button>
        </div>
      </div>
    </div>`);
      $('body').append(popwin).append('<div class="v-modal" tabindex="0" style="z-index: 2000;"></div>');
    }
  }
}
// 上传文件转base64
function getFileBase64(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    let fileResult = "";
    reader.readAsDataURL(file);
    reader.onload = function () {
      fileResult = reader.result;
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.onloadend = function () {
      resolve(fileResult);
    };
  });
}

export default {
  loginOptions,
  isEmpty,
  timetamp,
  removalSpace,
  specialCharacters,
  checkNumber,
  account_type_error,
  copyPictureCheck,
  getFileBase64,
}
